<template>
  <div class="section-box">
    <div class="customer-list">
      <el-row class="customer-row-bg">
        <el-col :span="15" style="text-align: left; display: flex; align-items: center;border: 0px solid blue;">
          <el-form :inline="true" label-width="100px" label-position="left">
            <el-form-item label="销售:">
              <!-- <el-input v-model="form.CompanyId" placeholder="客户企业"></el-input> -->
              <el-select v-model="form.SupaiSaleId" placeholder="请选择负责人">
                <el-option label="请选择负责人" :value="0"></el-option>
                <el-option v-for="(item, index) in adminUserData" :label="item.RealName" :value="item.AdminUserId"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发单时间：">
              <el-date-picker size="" v-model="searchTime" type="daterange" format="yyyy-MM-dd"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始"
                end-placeholder="结束" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="客户企业:">
              <el-select v-model="form.UserCode" clearable filterable remote placeholder="输入关键字搜索"
                :remote-method="searchUsersFromMongo" @clear="userList = []" :loading="searchUserLoading">
                <el-option v-for="item in userList" :key="item.UserCode" :label="item.UserNameAndCode"
                  :value="item.UserCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成时间：">
              <el-date-picker size="" v-model="searchTime" type="daterange" format="yyyy-MM-dd"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始"
                end-placeholder="结束" style="width: 100%;"></el-date-picker>
            </el-form-item> -->
          </el-form>
        </el-col>
        <el-col :span="9" style="border: 0px solid blue;"></el-col>
      </el-row>
      <el-row class="customer-row-bg">
        <el-col :span="15" style="text-align: left; display: flex; align-items: center;border: 0px solid blue;">
          <el-form :inline="true" label-width="100px" label-position="left">
            <!-- <el-form-item label="销售:">
              <el-select v-model="form.AdminUserId" placeholder="请选择负责人">
                <el-option label="请选择负责人" :value="0"></el-option>
                <el-option v-for="(item, index) in adminUserData" :label="item.RealName" :value="item.AdminUserId"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发单时间：">
              <el-date-picker size="" v-model="searchTime" type="daterange" format="yyyy-MM-dd"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始"
                end-placeholder="结束" style="width: 100%;"></el-date-picker>
            </el-form-item> -->
            <el-form-item label="客户企业:">
              <el-select v-model="form.UserCode" clearable filterable remote placeholder="请输入客户企业"
                :remote-method="searchUsersFromMongo" @clear="userList = []" :loading="searchUserLoading">
                <el-option v-for="item in userList" :key="item.UserCode" :label="item.UserNameAndCode"
                  :value="item.UserCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成时间：">
              <el-date-picker size="" v-model="completeTime" type="daterange" format="yyyy-MM-dd"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始"
                end-placeholder="结束" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="9" style="border: 0px solid blue;">
          <el-form inline label-width="90px" label-position="left" style="text-align: right;">
            <el-form-item>
              <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="medium" icon="el-icon-download" @click="exportExcel">导出</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 列表 -->
    <el-table :stripe="true" :data="tableData" border style="width: 100%; margin-top: 20px" v-loading="listLoading"
      :header-cell-style="{ background: '#F5F7FA' }">
      <!-- eslint-disable  -->
      <el-table-column label="工单ID" prop="0" show-overflow-tooltip width="75">
        <template slot-scope="scope">
          <span>{{ scope.row.JobId || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单编号" prop="0" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.JobNo || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单名称" show-overflow-tooltip width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.JobTitle || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系人" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.JobLinkMan || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系人电话" show-overflow-tooltip width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.JobHandSet || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="发单日期" show-overflow-tooltip width="180">
        <template slot-scope="scope">
          <span>{{ (scope.row.CreateDate) || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="客户企业名称" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ (scope.row.CompanyName) || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="销售" show-overflow-tooltip width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.SupaiSaleName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单省份" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span>{{ (scope.row.ProvinceName) || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单城市" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.CityName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上门名义" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.EngineerToDoorName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="地址" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.FullAddress || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="一级产品" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ (scope.row.OneProductName) || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="二级产品" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.TwoProductName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="三级产品" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.ThreeProductName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="品牌" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.BrandName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="系列" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.SeriesName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="行业" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.IndustryName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="状态" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.JobStatus || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="开始执行时间" show-overflow-tooltip width="115">
        <template slot-scope="scope">
          <span>{{ scope.row.ExecStartDateStr || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="截止执行时间" show-overflow-tooltip width="115">
        <template slot-scope="scope">
          <span>{{ scope.row.ExecEndDateStr || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="确认付款时间" show-overflow-tooltip width="115">
        <template slot-scope="scope">
          <span>{{ scope.row.CompleteTimeStr || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="年份" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.CompleteTimeYear || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="月份" show-overflow-tooltip width="70">
        <template slot-scope="scope">
          <span>{{ scope.row.CompleteTimeMonth || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上游费用" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.TrueTotalRealAmount || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="服务需求描述" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.ReportContent || "--" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.PageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getInvoiceJobList
} from "@/service/jobStatistics";
import {
  getAdminUser, //获取销售列表
} from "@/service/salesStatistics";
import { searchUsersFromMongo } from '@/service/login'
export default {
  data() {
    return {
      adminUserData: [],//销售列表

      searchTime: '',
      completeTime: '',
      listLoading: false,
      form: {
        PageNum: 1,
        PageSize: 10,
        // CompanyId: "",
        // CompanyName: "", //企业名称

        SupaiSaleId: 0,
        UserCode: "",
        StartDate: "",
        EndDate: "",
        StartCompleteDate: "",
        EndCompleteDate: "",
      },
      total: 0, //总条数
      tableData: [],

      pickerOptions: {
        shortcuts: [{
          text: '当月',
          onClick(picker) {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var str = year + '-' + month + "-1";
            var nmonth_first = new Date(str);

            picker.$emit('pick', [nmonth_first, today]);
          }
        }, {
          text: '当天',
          onClick(picker) {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            // var year=now.getFullYear();
            // var month=now.getMonth()+1;
            // var str=year+'-'+month+"-1";
            // var nmonth_first=new Date(str);

            picker.$emit('pick', [today, today]);
          }
        }]
      },

      searchUserLoading: false,//搜索用户的loadding
      userList: [] //收款账户下来搜索框
    };
  },
  created() {
    this.getAdminUserData();

    this.tableData = [];
    this.getInvoiceJobList();
  },

  methods: {
    //获取负责人
    async getAdminUserData() {
      var data = { RoleCodeArray: ["XSJL", "XSZG"] };
      let res = await getAdminUser(data);
      if (res.Result != 1) {
        return this.$message.error("获取负责人失败请联系开发人员");
      }
      this.adminUserData = res.Data.UserList;
    },
    // 查询
    handleSearch() {
      this.handleCurrentChange(1);
    },
    // 重置
    handleReset() {
      this.form.UserCode = "";
      this.form.SupaiSaleId = 0;
      // this.form.CompanyName = "";

      this.searchTime = '';
      this.completeTime='';

      this.form.StartDate = '';
      this.form.EndDate = '';

      this.form.StartCompleteDate = '';
      this.form.EndCompleteDate = '';
      this.tableData = [];
      
      this.handleSearch();
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = 1;
      this.form.PageSize = val;
      this.getInvoiceJobList();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = val;
      this.getInvoiceJobList();
    },

    //获取edi工单列表
    async getInvoiceJobList() {
      console.info('this.form.UserCode :' + this.form.UserCode);
      // if (this.form.UserCode == "") {
      //   return this.$message.warning("请输入客户企业");
      // }
      this.listLoading = true;
      if (this.searchTime && this.searchTime.length) {
        this.form.StartDate = this.searchTime[0];
        this.form.EndDate = this.searchTime[1];
      }
      else {
        this.form.StartDate = "";
        this.form.EndDate = "";
      }
      if (this.completeTime && this.completeTime.length) {
        this.form.StartCompleteDate = this.completeTime[0];
        this.form.EndCompleteDate = this.completeTime[1];
      }
      else {
        this.form.StartCompleteDate = "";
        this.form.EndCompleteDate = "";
      }
      let data = {
        CompanyId: 0,
        SupaiSaleId: this.form.SupaiSaleId,
        PageNum: this.form.PageNum,
        PageSize: this.form.PageSize,
      };
      if (this.form.UserCode != "") data.CompanyId = this.form.UserCode.substring(1, this.form.UserCode.length);
      if (this.form.StartDate != "") data.StartDate = this.form.StartDate;
      if (this.form.EndDate != "") data.EndDate = this.form.EndDate;

      if (this.form.StartCompleteDate != "") data.StartCompleteDate = this.form.StartCompleteDate;
      if (this.form.EndCompleteDate != "") data.EndCompleteDate = this.form.EndCompleteDate;

      console.log("data:" + JSON.stringify(data));

      let res = await getInvoiceJobList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error(res.Message);
      }
      this.tableData = res.Data.ModelList;
      this.total = res.Data.TotalCount;
    },
    //从mongo获取用户
    searchUsersFromMongo(seachKey) {
      console.log('seachKey:' + seachKey);
      seachKey = this.removeSpaces(seachKey);
      if (seachKey != "") {
        this.searchUserLoading = true;
        var that = this;
        console.log('---searchUsersFromMongo--');
        setTimeout(() => {
          var data = {
            PageNum: 1,
            PageSize: 100,
            UserType: 2,
            SearchKey: seachKey
          };
          console.log('data:' + JSON.stringify(data));
          let res = searchUsersFromMongo(data).then(res => {
            that.searchUserLoading = false;
            if (res.Result != 1) {
              return this.$message.error(res.Message);
            }
            that.userList = res.Data;
            console.log("userList:" + JSON.stringify(that.userList));

          });

        }, 200);
      }
      else {
        this.userList = [];
      }
    },
    exportExcel() {
      // if (this.form.UserCode == "") {
      //   return this.$message.warning("请输入客户企业");
      // }
      if (this.searchTime && this.searchTime.length) {
        this.form.StartDate = this.searchTime[0];
        this.form.EndDate = this.searchTime[1];
      }
      else {
        this.form.StartDate = "";
        this.form.EndDate = "";
      }
        if (this.completeTime && this.completeTime.length) {
        this.form.StartCompleteDate = this.completeTime[0];
        this.form.EndCompleteDate = this.completeTime[1];
      }
      else {
        this.form.StartCompleteDate = "";
        this.form.EndCompleteDate = "";
      }
      let data = {
        CompanyId: 0,
        SupaiSaleId: this.form.SupaiSaleId,
        PageNum: this.form.PageNum,
        PageSize: this.form.PageSize,
      };
      if (this.form.UserCode != "") data.CompanyId = this.form.UserCode.substring(1, this.form.UserCode.length);
      // if (this.form.CompanyId != "") data.CompanyId = this.form.CompanyId;
      // if (this.form.CompanyName != "") data.CompanyName = this.form.CompanyName;
      if (this.form.StartDate != "") data.StartDate = this.form.StartDate;
      if (this.form.EndDate != "") data.EndDate = this.form.EndDate;
      if (this.form.StartCompleteDate != "") data.StartCompleteDate = this.form.StartCompleteDate;
      if (this.form.EndCompleteDate != "") data.EndCompleteDate = this.form.EndCompleteDate;


      let url =
        process.env.NODE_ENV == "development"
          ? "/api4"
          : process.env.VUE_APP_API4;
      window.open(
        url +
        "/api/JobStatistics/ExportInvoiceJob?" +
        this.parseJsonURL(data)
      );
    },
    parseJsonURL(json) {
      if (!json) return "";
      if (typeof json == "string") return json;
      return this.cleanArray(
        Object.keys(json).map(function (key) {
          if (json[key] === undefined) return "";
          return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
      ).join("&");
    },
    cleanArray(actual) {
      var newArray = [];
      for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
          newArray.push(actual[i]);
        }
      }
      return newArray;
    },
    removeSpaces(str) {
      return str.replace(/\s+/g, '');
    }
  },
};
</script>
<style lang="scss" scoped>
.customer-list {
  position: relative;
  background-color: #f9fafc;

  .next-button {
    position: absolute;
    right: 0;
    top: -56px;
  }
}

.customer-row-bg {
  margin: 0px;
  padding: 5px 14px;
  background-color: #f9fafc;
  // display: flex;
  // align-items: center;
  // border: 1px solid red;

  .el-form-item {
    margin-bottom: 8px !important;
  }

  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
</style>